import moment from "moment"

export const getFeeDate = (feeScreenshot, module) => {
  if (!feeScreenshot[module]) return
const feeDate = feeScreenshot[module]?.date?.seconds
  return feeDate? moment(feeDate * 1000).format("LLL") : <span className="not-enrolled">Not Enrolled</span>
}

export const getFeeStatus = (feeScreenshot, module, status) => {
  if (!feeScreenshot?.[module]) return
  return feeScreenshot[module]?.status === status
}

export const getFeeAmount = (feeScreenshot, module) => {
  if (!feeScreenshot[module]) return
  return feeScreenshot[module]?.feeAmount
}